module.exports = __webpack_public_path__ + "img/plane-arrival.c84ce615.svg";